var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',{staticStyle:{"width":"300px"}},[_c('v-text-field',{attrs:{"label":"Search","single-line":"","outlined":"","full-width":"","prepend-inner-icon":"fas fa-search","dense":"","rounded":"","background-color":"#ffffff"},on:{"input":_vm.setModelData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }